import React, { Component } from 'react';
import { EventConsumer } from '../core/providers/EventProvider';
import EventSnack from './EventSnack';
import GS from '../grafsync/grafsync';

class EventBar extends Component {

    render() {

        return (
            <EventConsumer>
                {({ event }) => {
                    if (event) {
                        let additionalText = "";
                        let message = "";
                        switch (event.type) {
                            case GS.EVENTS.EVENT_RESOURCE_CREATE:
                                message = "Another user just created " + event.data.channel;
                                break;
                            case GS.EVENTS.EVENT_EDIT:
                                message = event.data.text.join(". ");
                                break;
                            case GS.EVENTS.EVENT_CONCURRENT_EDIT:
                                message = "A conflicting concurrent edit has been made.";
                                additionalText = event.data.text.join(". ");
                                break;
                            default:
                        }
                        if (event.type === GS.EVENTS.EVENT_RESOURCE_CREATE) {
                            switch (event.data.class) {
                                case 'http://www.w3.org/2008/05/skos-xl#Label':
                                    additionalText = "This is a SKOS-XL Label.";
                                    break;
                                case "http://www.w3.org/2004/02/skos/core#Concept":
                                    additionalText = "This is a SKOS Concept.";
                                    break;
                                default:
                            }
                        }
                        const additionalMessage = additionalText !== "" ? <p>{additionalText}</p> : null;
                        return <EventSnack key={message + additionalMessage} message={<p>{message}</p>} additionalMessage={additionalMessage} />
                    }
                }
                }
            </EventConsumer>
        );
    }
}

export default EventBar;